export default {"src":"/_next/static/media/clockIcon.a6798fa5.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};